var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMypage = function SvgMypage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24a11.882 11.882 0 0 1-5.237-1.2c-.597-.29-1.169-.63-1.71-1.014l-.164-.12A12.106 12.106 0 0 1 1.332 17.5 11.869 11.869 0 0 1 0 12C0 5.373 5.373 0 12 0s12 5.373 12 12a11.87 11.87 0 0 1-1.33 5.498 12.109 12.109 0 0 1-3.553 4.164c-.56.41-1.155.772-1.778 1.08l-.096.048A11.88 11.88 0 0 1 12 24Zm0-6a4.788 4.788 0 0 0-4.268 2.6 9.617 9.617 0 0 0 8.536 0v-.006A4.784 4.784 0 0 0 12 18Zm0-2.4a7.218 7.218 0 0 1 6.275 3.667l.018-.015.017-.015-.02.018-.013.01a9.6 9.6 0 1 0-12.552 0A7.22 7.22 0 0 1 12 15.6Zm0-1.2a4.8 4.8 0 1 1 0-9.6 4.8 4.8 0 0 1 0 9.6Zm0-7.2a2.4 2.4 0 1 0 0 4.8 2.4 2.4 0 0 0 0-4.8Z",
    fill: "#333"
  })));
};
export default SvgMypage;